import { themedStyled } from 'common/styles/styletron.theme';
import { Input } from 'components/elements';
import {
  FullContainer,
  HalfContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import HotelTable from './hotel-table';

export default function TourHotelItem(props: { parentIdx: number }) {
  const { t } = useTranslation();

  return (
    <FullContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name={`approvalable.tourHotels[${props.parentIdx}].hotelName`}
            label={t('common:hotel')}
            placeholder={t('common:hotel')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name={`approvalable.tourHotels[${props.parentIdx}].note`}
            label={t('common:note')}
            placeholder={t('common:note')}
          />
        </HalfContainer>
      </SectionContainer>
      <HotelTable parentIdx={props.parentIdx} />
    </FullContainer>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
